"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = edit;

var _request = _interopRequireDefault(require("@/utils/request"));

function edit(data) {
  return (0, _request.default)({
    url: '/feedback/edit',
    method: 'post',
    data: data
  });
}